/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useEffect, useState } from 'react';
import { getQuestions } from '../services/fetch';
import { LEAD_ID } from '../services/urls';
import { User } from '../types/Application';
import { QuestionSubmit, Quiz } from '../types/Quiz';

type AppContextType = {
    // states
    quizAnswers: QuestionSubmit[];
    user: User;
    quizData: Quiz | undefined;
    pageView: string;
    loading: boolean;
    questionIndex: number;
    quizTime: Date | undefined;

    setQuizAnswers: (value: QuestionSubmit[]) => void;
    setCurrentUser: (value: User) => void;
    setQuizData: (value: Quiz | undefined) => void;
    setPageView: (value: string) => void;
    setLoading: (value: boolean) => void;
    setQuestionIndex: (value: number) => void;
    setQuizTime: (value: Date | undefined) => void;
}

const AppContext = createContext<AppContextType | undefined>(undefined);
const { Provider } = AppContext;
const AppProvider = ({ children }: any) => {
    const [quizAnswers, setQuizAnswers] = useState<QuestionSubmit[]>([]);
    const [user, setCurrentUser] = useState<User>({ LeadID: LEAD_ID });
    const [quizData, setQuizData] = useState<Quiz | undefined>(undefined);
    const [pageView, setPageView] = useState<string>("start");
    const [loading, setLoading] = useState<boolean>(false);
    const [questionIndex, setQuestionIndex] = useState<number>(0);
    const [quizTime, setQuizTime] = useState<Date | undefined>(undefined);

    const state = {
        quizAnswers,
        user,
        quizData,
        pageView,
        loading,
        questionIndex,
        quizTime
    }

    const actions = {
        setQuizAnswers,
        setCurrentUser,
        setQuizData,
        setPageView,
        setLoading,
        setQuestionIndex,
        setQuizTime
    }


    useEffect(() => {
        getQuestions(setQuizData);
    }, []);

    useEffect(() => {
        console.log(pageView);
    }, [pageView])


    return (
        <Provider value={{ ...actions, ...state }}>{children}</Provider>
    )
}
export { AppContext, AppProvider }